import React from 'react';
import { Button } from './ui/button';
import { Calendar, Megaphone, Handshake } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'Schedule a Free Consultation',
    description: 'We walk through your goals, timeline, and build a pricing strategy tailored to your home.',
    icon: <Calendar className="w-8 h-8 text-gold" data-id="element-213" />
  }, {
    number: '02',
    title: 'List with Professional Marketing',
    description: 'High-end photography, compelling listing copy, and syndication to every major platform.',
    icon: <Megaphone className="w-8 h-8 text-gold" data-id="element-214" />
  }, {
    number: '03',
    title: 'Close and Keep Thousands More',
    description: 'We handle negotiations and paperwork while you walk away with significantly more equity.',
    icon: <Handshake className="w-8 h-8 text-gold" data-id="element-215" />
  }];
  return <section className="py-20 md:py-32 bg-white border-t border-border" data-id="element-216">
      <div className="container mx-auto px-4 md:px-6" data-id="element-217">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24" data-id="element-218">
          <p className="text-gold text-xs font-bold tracking-[0.2em] uppercase mb-4" data-id="element-219">
            The Process
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal leading-tight" data-id="element-220">
            Sell with confidence in three steps.
          </h2>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-16" data-id="element-221">
          {/* Desktop Connecting Line */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-[1px] bg-gold/30 z-0" data-id="element-222" />

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-223">
              <div className="w-24 h-24 bg-cream rounded-full flex items-center justify-center mb-8 border border-gold/20 shadow-sm" data-id="element-224">
                <span className="font-serif text-3xl text-brick-red" data-id="element-225">
                  {step.number}
                </span>
              </div>
              <div className="mb-4" data-id="element-226">{step.icon}</div>
              <h3 className="font-serif text-xl md:text-2xl text-charcoal mb-4" data-id="element-227">
                {step.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed max-w-sm" data-id="element-228">
                {step.description}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-229">
          <Button className="bg-brick-red hover:bg-brick-red-dark text-white h-14 px-10 text-lg w-full sm:w-auto" data-id="element-230">
            Start With a Free Consultation
          </Button>
        </div>
      </div>
    </section>;
}